import { defineDirective, FieldViewModel, isArrayEmpty } from "../omnia"
import { INutritionService } from "../types"

export class NotificationsCtrl {

    static create() {
        return defineDirective(NotificationsCtrl, "app/nutrition/notifications/notifications.html", {})
    }

    public visible: boolean = true

    public mismatchedCrops: FieldViewModel[]

    static $inject = ["$scope", "OmniaNutritionService"]

    constructor(private $scope: ng.IScope, private readonly svc: INutritionService) {

    }

    $onInit() {

        this.$scope.$watch(() => this.svc.getNotifications(), n => {
            this.mismatchedCrops = n?.mismatchedCrops ?? []
            this.visible = !isArrayEmpty(this.mismatchedCrops)
        })

    }

}

